module.exports = __webpack_public_path__ + "stripe-logo.png?22080c4217232fbd061fac6f66360c60";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stripe-logo.png
// module id = 1034
// module chunks = 0